import React from "react";
import { Row, Col, Space } from 'antd';
import { Descriptions, Table } from 'antd';
import { Input } from 'antd';
import _, { isEmpty } from 'lodash';
import { isNil } from "lodash";
import { DataTable } from "components";

const { TextArea } = Input;


const IntervCostTable = (props) => {

  const thermIns = props.data?.thermIns;
  const shellReplace = props.data?.shellReplace;
  const upgradeSys = props.data?.upgradeSys;
  const otherServices = props.data?.otherServices;
  const total = true

  const conditions = {
    thermIns,
    shellReplace,
    upgradeSys,
    otherServices,
    total
  };

  const dataSource = [
    {
      type: 'Εφαρμογή συστήματος θερμομόνωσης σε αδιαφανή στοιχεία του κελύφους',
      amount: props.data.amountThermIns + ' €',
      fpa: props.data.amountThermInsFpa + ' €',
      key: 'thermIns'
    },

    {
      type: 'Αντικατάσταση διαφανών στοιχείων (κουφωμάτων) του κελύφους',
      amount: props.data.amountShellReplace + ' €',
      fpa: props.data.amountShellReplaceFpa + ' €',
      key: 'shellReplace'
    },
    {
      type: 'Αναβάθμιση συστήματος θέρμανσης (ή και ψύξης) χώρων',
      amount: props.data.amountUpgradeSys + ' €',
      fpa: props.data.amountUpgradeSysFpa + ' €',
      key: 'upgradeSys'
    },
    {
      type: 'Λοιπές Υπηρεσίες',
      amount: props.data.amountOtherServices + ' €',
      fpa: props.data.amountOtherServicesFpa + ' €',
      key: 'otherServices'
    },
    {
      type: <div className="d-flex justify-content-between">
        <span>Συνολικό Κόστος Παρέμβασης Με ΦΠΑ</span>
        <span>{props.data.totalCostWithFpa
          ? new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(props.data.totalCostWithFpa)
          : "-"}
        </span>
      </div>,
      amount: <div className="d-flex justify-content-between">
        <span className="mr-2" style={{textAlign: 'left'}}>Συνολικό Κόστος Παρέμβασης Χωρίς ΦΠΑ</span>
        <span>{props.data.totalCost
          ? new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(props.data.totalCost)
          : "-"}
        </span>
      </div>,
      fpa: <div className="d-flex justify-content-between">
        <span>Συνολικό ΦΠΑ</span>
        <span>{props.data.totalFpa
          ? new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(props.data.totalFpa)
          : "-"}
        </span>
      </div>,
      key: 'total'
    },

  ]

  const filteredDataSource = dataSource.filter(row => conditions[row.key]);

  const tableColumns = [
    {
      title: 'Τύπος Δαπάνης',
      dataIndex: 'type',
      key: 'type',
      render: (text) => (
        <span>{text}</span>
      ),
      align: 'left',
      width: '60%',
    },
    {
      title: 'Ποσό Χωρίς ΦΠΑ',
      dataIndex: 'amount',
      key: 'amount',
      // render: (text) => (
      //   <span className="">{text}</span>
      // ),
      align: 'right',
      width: '50%',
    },
    {
      title: 'ΦΠΑ',
      dataIndex: 'fpa',
      key: 'fpa',
      // render: (text) => (
      //   <span>{text}</span>
      // ),
      align: 'right',
      width: '35%',
    },
  ];

  let locale = {
    emptyText: 'Δε βρέθηκαν στοιχεία',
  };

  return (
    <>
      <Row gutter={32}>
        <Col span={24} style={{ marginTop: "3rem" }}>
          <div className="color-blue-3 text-bold font-size-24 mb-4">Κόστος Παρέμβασης</div>

          <DataTable className={`${!isEmpty(filteredDataSource) ? 'table-with-totals-purple' : 'table-with-totals-purple table-no-data'}`} locale={locale} dataSource={filteredDataSource} columns={tableColumns} pagination={false}
          />

        </Col>
      </Row>
    </>
  )
}

export default IntervCostTable